import React from 'react';
import c from 'classnames';
import s from './ModalFooter.scss';
/**
 * The bottom portion of a modal. It has slots for it's left and right sides.
 */ const ModalFooter = ({ className , left =[] , right =[]  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, left.map((item, index)=>item && /*#__PURE__*/ React.createElement("div", {
            key: `footer-item-${index}`,
            className: s['left-side-item-wrapper']
        }, item))), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, right.map((item, index)=>item && /*#__PURE__*/ React.createElement("div", {
            key: `footer-item-${index}`,
            className: s['right-side-item-wrapper']
        }, item))));
};
ModalFooter.displayName = 'ModalFooter';
export default ModalFooter;
